<app-layout>
  <app-voltar route="{{ this.backRoute }}" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <app-subtitulo>
        Informe o número da entrada ou a placa do cavalo e confirme os dados
      </app-subtitulo>
      <div class="formList">
        <app-input
          type="text"
          label="N° da Entrada"
          name="FK_GATE_ENTR"
          formControlName="FK_GATE_ENTR"
          placeholder="Digite aqui"
          (blurEvent)="getEntrada('FK_GATE_ENTR')"
          [requiredInput]="true"
          [disabled]="isEditing || !!entradaCarregada"></app-input>
        <app-input
          type="text"
          label="N° do Agendamento"
          name="PK_AGND"
          formControlName="PK_AGND"
          placeholder="Digite aqui"
          (blurEvent)="getEntrada('PK_AGND')"
          [disabled]="isEditing || !!entradaCarregada"></app-input>
        <app-input
          type="text"
          label="Data do Agendamento"
          name="DT_AGND"
          formControlName="DT_AGND"
          placeholder="---"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Janela"
          name="JANELA"
          formControlName="JANELA"
          placeholder="---"
          [disabled]="true"></app-input>
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          mask="AAA-0A00"
          (blurEvent)="getEntrada('TX_PLCA_CAVA')"
          [requiredInput]="true"
          [disabled]="isEditing || isViewing || !!entradaCarregada"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Aguardando"
          [disabled]="true"></app-input>
        <app-input
          type="disabled"
          label="Carretas"
          name="TX_PLCA_CRTS"
          formControlName="TX_PLCA_CRTS"
          placeholder="Aguardando"
          [disabled]="true"></app-input>
        <div class="empresa-faturada">
          <app-input
            type="disabled"
            label="Empresa"
            name="NM_EPSA"
            formControlName="NM_EPSA"
            placeholder="Aguardando"
            [disabled]="true"></app-input>
          <app-botao
            *ngIf="
              !isEditing && !isViewing && form.controls['FK_GATE_ENTR'].value
            "
            text="Faturar"
            icon="assets/bx-money.svg"
            (click)="openEmpresasFaturadas()"
            [disabled]="disableFaturar()"></app-botao>
        </div>
        <app-input
          type="text"
          label="Observação da Saída"
          name="TX_OBSV_GATE_SAID"
          formControlName="TX_OBSV_GATE_SAID"
          placeholder="Digite aqui"></app-input>
      </div>
      <div class="tabela">
        <h2 *ngIf="isLoading">Carregando...</h2>
        <app-tabela
          *ngIf="!isLoading && tableData.length > 0"
          [data]="tableData"
          [columns]="tableColumns"></app-tabela>
        <h2
          *ngIf="
            !isLoading &&
            form.controls['FK_GATE_ENTR'].value &&
            !tableData.length
          ">
          Esta saída não possui serviços
        </h2>
      </div>
      <div class="tabela-mobile">
        <h2 *ngIf="isLoading">Carregando...</h2>
        <app-card
          *ngIf="!isLoading && tableData.length > 0"
          [data]="tableData"
          [rows]="tableColumns"
          [expand]="true"></app-card>
        <h2
          *ngIf="
            !isLoading &&
            form.controls['FK_GATE_ENTR'].value &&
            !tableData.length
          ">
          Esta saída não possui serviços
        </h2>
      </div>

      <div class="botao-pagamento">
        <app-botao
          *ngIf="showBotaoPagamento()"
          text="Pagamento"
          icon="assets/bx-money.svg"
          (click)="openModalPagamento()"
          [disabled]="disablePagamento()"></app-botao>
      </div>

      <div class="grid-inputs-4">
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value && flPrePatio"
          type="money"
          label="Pré-Pátio"
          name="VL_PRE_PTIO"
          formControlName="VL_PRE_PTIO"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Total"
          name="VL_TOTL"
          formControlName="VL_TOTL"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="!isEmpresaFaturada && form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Pago"
          name="VL_PAGO"
          formControlName="VL_PAGO"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Restante"
          name="VL_REST"
          formControlName="VL_REST"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Desconto Disp."
          name="VL_DSCT_PREV"
          formControlName="VL_DSCT_PREV"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Desconto"
          name="VL_DSCT"
          formControlName="VL_DSCT"
          [disabled]="true"></app-input>
        <app-input
          *ngIf="form.controls['FK_GATE_ENTR'].value"
          type="money"
          label="Acréscimo"
          name="VL_ACRM"
          formControlName="VL_ACRM"
          [disabled]="true"></app-input>
      </div>
      <div class="form-button">
        <app-botao
          *ngIf="!isViewing"
          type="cadastro"
          class="botao-cadastro"
          [text]="isEditing ? 'Editar Saída' : 'Registrar Saída'"
          (click)="createSaida()"
          [disabled]="disableCadastro()"></app-botao>
      </div>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
